var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var modalActions = require('../../../modules/modals/actions/modal');
var Modal = require('./modal.jsx');

var SponsoredModal = createReactClass({
  mixins: [PureRenderMixin],

  getInitialState: function(){
    return {
      isAdLoaded: false
    };
  },

  componentDidUpdate: function(){
    var $this = $(ReactDOM.findDOMNode(this));
    var $ad_iframe = $this.find('iframe');
    if($ad_iframe.length){
      $ad_iframe.off('load');
      $ad_iframe.on('load', function(){
        this.setState({
          isAdLoaded: true
        });
      }.bind(this));
    }
  },

  onClose: function() {
    this.props.hideModal();
  },

  render: function(){
    var id = this.props.modal.props.id || 'sponsored';

    return (
      <Modal onClose={this.onClose} id={id} className={this.state.isAdLoaded ? '' : 'ad-loading loading'}>
        <div className="reveal-hd"><h3>{this.props.modal.title}</h3></div>
        <div className="reveal-bd" style={{paddingTop: this.props.modal.props.placement.height/this.props.modal.props.placement.width * 100 + '%'}}>
          {this.props.modal.props.placement.tracking_pixel &&
            <img className="hide" src={this.props.modal.props.placement.tracking_pixel} alt="" />
          }
          <div dangerouslySetInnerHTML={{__html: this.props.modal.props.placement.body}}></div>
        </div>
      </Modal>
    );
  }
});

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(modalActions, dispatch);
}

module.exports = ReactRedux.connect(null, mapDispatchToProps)(SponsoredModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/sponsoredModal.jsx